// ======================================================================
// FILE:
// src/modules/expense_management/claims/components/ExpenseClaimFilterBar.jsx
//
// MODULE:
// Expense Management
//
// FEATURE:
// Expense Claim Filter Bar
// ======================================================================

import React, {
  useState,
  useEffect,
} from "react";

export default function ExpenseClaimFilterBar({

  filters = {},

  onApply,

}) {

  const [form, setForm] =
    useState(filters);

  useEffect(() => {

    setForm(filters);

  }, [filters]);

  function update(field, value) {

    setForm((prev) => ({

      ...prev,

      [field]: value,

    }));

  }

  function handleSearch() {

    onApply?.(form);

  }

  function handleReset() {

    const reset = {

      q: "",

      employee_id: "",

      expense_policy_id: "",

      status: "",

      project_id: "",

      cost_center_id: "",

      from_date: "",

      to_date: "",

    };

    setForm(reset);

    onApply?.(reset);

  }

  return (

    <div className="card shadow-sm mb-4">

      <div className="card-body">

        <div className="row g-3">

          {/* ====================================================== */}
          {/* SEARCH */}
          {/* ====================================================== */}

          <div className="col-lg-3">

            <label className="form-label">

              Search

            </label>

            <input

              className="form-control"

              placeholder="Claim No / Purpose"

              value={form.q || ""}

              onChange={(e) =>
                update(
                  "q",
                  e.target.value
                )
              }

            />

          </div>

          {/* ====================================================== */}
          {/* EMPLOYEE */}
          {/* ====================================================== */}

          <div className="col-lg-2">

            <label className="form-label">

              Employee

            </label>

            <select

              className="form-select"

              value={
                form.employee_id || ""
              }

              onChange={(e) =>
                update(
                  "employee_id",
                  e.target.value
                )
              }

            >

              <option value="">
                All
              </option>

            </select>

          </div>

          {/* ====================================================== */}
          {/* STATUS */}
          {/* ====================================================== */}

          <div className="col-lg-2">

            <label className="form-label">

              Status

            </label>

            <select

              className="form-select"

              value={
                form.status || ""
              }

              onChange={(e) =>
                update(
                  "status",
                  e.target.value
                )
              }

            >

              <option value="">
                All
              </option>

              <option value="DRAFT">
                Draft
              </option>

              <option value="SUBMITTED">
                Submitted
              </option>

              <option value="PENDING">
                Pending
              </option>

              <option value="APPROVED">
                Approved
              </option>

              <option value="REJECTED">
                Rejected
              </option>

              <option value="PAID">
                Paid
              </option>

            </select>

          </div>

          {/* ====================================================== */}
          {/* POLICY */}
          {/* ====================================================== */}

          <div className="col-lg-2">

            <label className="form-label">

              Expense Policy

            </label>

            <select

              className="form-select"

              value={
                form.expense_policy_id || ""
              }

              onChange={(e) =>
                update(
                  "expense_policy_id",
                  e.target.value
                )
              }

            >

              <option value="">
                All
              </option>

            </select>

          </div>

          {/* ====================================================== */}
          {/* PROJECT */}
          {/* ====================================================== */}

          <div className="col-lg-3">

            <label className="form-label">

              Project

            </label>

            <select

              className="form-select"

              value={
                form.project_id || ""
              }

              onChange={(e) =>
                update(
                  "project_id",
                  e.target.value
                )
              }

            >

              <option value="">
                All
              </option>

            </select>

          </div>

          {/* ====================================================== */}
          {/* COST CENTER */}
          {/* ====================================================== */}

          <div className="col-lg-3">

            <label className="form-label">

              Cost Center

            </label>

            <select

              className="form-select"

              value={
                form.cost_center_id || ""
              }

              onChange={(e) =>
                update(
                  "cost_center_id",
                  e.target.value
                )
              }

            >

              <option value="">
                All
              </option>

            </select>

          </div>

          {/* ====================================================== */}
          {/* FROM DATE */}
          {/* ====================================================== */}

          <div className="col-lg-2">

            <label className="form-label">

              From Date

            </label>

            <input

              type="date"

              className="form-control"

              value={
                form.from_date || ""
              }

              onChange={(e) =>
                update(
                  "from_date",
                  e.target.value
                )
              }

            />

          </div>

          {/* ====================================================== */}
          {/* TO DATE */}
          {/* ====================================================== */}

          <div className="col-lg-2">

            <label className="form-label">

              To Date

            </label>

            <input

              type="date"

              className="form-control"

              value={
                form.to_date || ""
              }

              onChange={(e) =>
                update(
                  "to_date",
                  e.target.value
                )
              }

            />

          </div>

          {/* ====================================================== */}
          {/* ACTIONS */}
          {/* ====================================================== */}

          <div
            className="
              col-lg-2
              d-flex
              align-items-end
            "
          >

            <div className="w-100">

              <button

                className="
                  btn
                  btn-primary
                  w-100
                "

                onClick={
                  handleSearch
                }

              >

                <i className="fas fa-search me-2" />

                Search

              </button>

            </div>

          </div>

          <div
            className="
              col-lg-2
              d-flex
              align-items-end
            "
          >

            <div className="w-100">

              <button

                className="
                  btn
                  btn-outline-secondary
                  w-100
                "

                onClick={
                  handleReset
                }

              >

                Reset

              </button>

            </div>

          </div>

        </div>

      </div>

    </div>

  );

}